import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import submit from "submit-form";

const TeamEnd = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const cycle = locals?.editCycle;

  const [firstConfirmation, setFirstConfirmation] = useState(false);

  const fromTemplates = (locals?.pathname || locals?.path || "").includes(
    "/templates/teams"
  );

  const handleDelete = (cycleId) => {
    submit(`/actions/cycle/cycle-teams-end-program/${cycleId}`, {
      method: "POSt",
      body: {
        fromTemplates,
      },
    });
  };

  return (
    <ConfirmationModal
      isOpen={true}
      title={
        !firstConfirmation
          ? t("teams.teamEnd.title")
          : t("teams.teamEnd.deleteConfirmTitle", { cycleName: cycle?.name })
      }
      contentText={
        !firstConfirmation ? (
          t("teams.teamEnd.endConfirmMessage", { cycleName: cycle?.name })
        ) : (
          <>
            <p>{t("teams.teamEnd.cannotUndo")}</p>
            <p>● {t("teams.teamEnd.membersRemoved")}</p>
            <p>● {t("teams.teamEnd.programDataDeleted")}</p>
          </>
        )
      }
      cancelButtonText={t("teams.teamEnd.cancel")}
      cancelButtonAction={() => {
        submit(`/actions/refresh?`, {
          method: "GET",
          body: {
            "modal[type]": "",
            cycleId: "",
          },
        });
      }}
      confirmButtonText={t("teams.teamEnd.delete")}
      confirmButtonAction={() => {
        if (!firstConfirmation) {
          setFirstConfirmation(true);
        } else {
          handleDelete(cycle._id);
        }
      }}
      icon="delete"
      toClear={["cycleId"]}
    />
  );
};

export default TeamEnd;
